<template>
  <div class="system-pageAddD" id="app" style="overflow-y: scroll;">
    <mt-header title="公文修改">
      <mt-button icon="back" slot="left" @click.native="goBack">返回</mt-button>
    </mt-header>
    <div v-if="isLoading" class="back-loading">数据加载中...</div>
    <div style="width: 21rem; ">
      <div class="userinfoAdd">
        <div style="border-bottom: 1px solid #e0d8d8">
          <van-field v-model="userName" label="发起人" readonly />
        </div>
        <van-field
            v-model="company"
            type="text"
            label="来文单位"
        />
        <div class="field-vertical-wrapper">
          <div class="field-vertical-label">文件原号</div>
          <van-field
              v-model="documentnum"
              type="text"
              class="field-vertical-input"
          />
        </div>
        <mt-cell label="收文日期" @click.native="selectLastRepairTime">
          <div style="font-size: 1.2rem;color: black;">{{ applyTime }}</div>
          <img
              style="width: 2rem; padding-right: 0.5rem"
              v-if="!applyTime"
              src="@/assets/icons/svg/dateChoose.svg"
          />
          <div class="mint-field-clear" v-else @click.stop="clearLastRepairTime">
            <i class="mintui mintui-field-error"></i>
          </div>
        </mt-cell>
        <div class="field-vertical-wrapper">
          <div class="field-vertical-label">文件标题</div>
          <van-field
              v-model="documentName"
              type="textarea"
              rows="2"
              autosize
              class="field-vertical-input"
          />
        </div>
        <van-field name="uploader" label="附件">
          <template #input>
            <div class="btn btn-default" style="position: relative; overflow: hidden; margin-top: 6px;">
              <i class="glyphicon glyphicon-open"></i> 上传附件
              <input type="file" name="filePath" style="opacity: 0; position: absolute; top: 12px; right: 0; " class='inpu' @change="fileListChange">
            </div>
          </template>
        </van-field>
        <van-field name="uploader" label="">
          <template #input>
            <div v-if="fileList.length!=0 || existingAttachments.length!=0" style="display: flex; flex-direction: column;">
              <div
                  v-for="(item, idx) in existingAttachments"
                  :key="'existing-' + idx"
                  style="display: flex; align-items: center; margin-bottom: 5px;">
                <span>{{ item.attachmentName }}</span>
                <div class="nameusersub" @click.prevent="previewFile(item)">预览</div>
                <div class="delete-btn" @click.prevent="removeExistingAttachment(idx)">x</div>
              </div>
              <div
                  v-for="(item, idx) in fileList"
                  :key="'new-' + idx"
                  style="display: flex; align-items: center; margin-bottom: 5px;">
                <span>{{ item }}</span>
                <div class="delete-btn" @click.prevent="fileListdel(item)">x</div>
              </div>
            </div>
          </template>
        </van-field>
        <div style="border-bottom: 2px solid #e0d8d8">
          <van-field v-model="nameuser" label="拟办人员" />
        </div>
        <div class="sub" @click.prevent="handelSubmit">修改</div>
      </div>
    </div>
    <!-- 收文时间选择 -->
    <van-calendar
        v-model="lastRepairTimeVisible"
        type="single"
        :min-date="minDate"
        @confirm="onLastRepairTimeConfirm"
    >
    </van-calendar>
  </div>
</template>

<script>
import {Toast} from "mint-ui";
import {getLocalData} from "@/utils/sessionData";
import axios from "axios";
import request from "@/utils/keyCloakRequest";

export default {
  data() {
    return {
      currentStartDate: new Date(),
      company: "",
      applyTime: "",
      documentnum: "",
      fileList: [],
      fileIds: [],
      existingFileIds: [],
      existingAttachments: [],
      documentName: "",
      userName: "",
      userId: "",
      nameuser: "",
      documentId: "",
      lastRepairTimeVisible: false,
      minDate: new Date(2020, 0, 1),
      userInfo: {},
      isLoading: false,
      route: ""
    };
  },
  async created() {
    this.userInfo = JSON.parse(getLocalData("userInfo"));
    this.userName = this.userInfo.userName;
    this.userId = this.userInfo.userId;
    this.item = this.$route.query.item;
    this.route = this.$route.query.route || "/document/documentList";
    this.documentId = this.item.documentId;
    
    // 加载原有数据
    if (this.item) {
      this.company = this.item.company || "";
      this.documentnum = this.item.documentnum || "";
      // 确保日期格式为 yyyy-MM-dd
      if (this.item.applyTime) {
        if (this.item.applyTime instanceof Date) {
          this.applyTime = this.formatDate(this.item.applyTime);
        } else if (typeof this.item.applyTime === 'string') {
          // 如果是字符串，尝试解析并格式化
          const date = new Date(this.item.applyTime);
          if (!isNaN(date.getTime())) {
            this.applyTime = this.formatDate(date);
          } else {
            // 如果已经是 yyyy-MM-dd 格式，直接使用
            if (/^\d{4}-\d{2}-\d{2}$/.test(this.item.applyTime)) {
              this.applyTime = this.item.applyTime;
            } else {
              this.applyTime = "";
            }
          }
        } else {
          this.applyTime = "";
        }
      } else {
        this.applyTime = "";
      }
      this.documentName = this.item.documentName || "";
      this.nameuser = this.item.proposedUserName || "";
      
      // 加载原有附件
      if (this.item.fileId) {
        this.existingFileIds = this.item.fileId.split(',').filter(id => id);
        request({
          url: "appDocumentFile?fileIds=" + this.item.fileId,
          method: "get"
        }).then(response => {
          this.existingAttachments = response || [];
        });
      }
    }
  },
  methods: {
    previewFile(attachment) {
      this.$router.push({
        name: 'filePreview',
        query: {
          attachment: attachment,
          item: this.item,
          route: this.route,
          name: 'proposedDocumentListEdit'
        },
      });
    },
    removeExistingAttachment(index) {
      const removed = this.existingAttachments.splice(index, 1)[0];
      // 从existingFileIds中移除对应的ID
      const fileIdIndex = this.existingFileIds.indexOf(String(removed.attachmentId));
      if (fileIdIndex > -1) {
        this.existingFileIds.splice(fileIdIndex, 1);
      }
    },
    // 清除时间
    clearLastRepairTime() {
      if (this.applyTime) {
        this.applyTime = '';
      }
    },
    selectLastRepairTime() {
      this.lastRepairTimeVisible = true;
    },
    onLastRepairTimeConfirm(value) {
      this.applyTime = this.formatDate(value);
      this.lastRepairTimeVisible = false;
    },
    formatDate(timestamp) {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    fileListChange(event) {
      const file = event.target.files[0];
      this.fileList.push(file.name);
      axios({
        url: process.env.VUE_APP_SSO_URL + "appSaveDfile",
        method: "POST",
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: {file: file, userId: this.userId}
      }).then(response => {
        this.fileIds.push(response.data.attachmentId);
      });
    },
    fileListdel(attachment) {
      const index = this.fileList.indexOf(attachment);
      this.fileList.splice(index, 1);
      this.fileIds.splice(index, 1);
    },
    goBack() {
      this.$router.push(this.route);
    },
    async handelSubmit() {
      if (!this.company) {
        Toast({
          message: "请填写来文单位"
        });
        return;
      }
      if (!this.documentnum) {
        Toast({
          message: "请填写文件原号"
        });
        return;
      }
      if (!this.applyTime) {
        Toast({
          message: "请选择收文时间"
        });
        return;
      }
      if (!this.documentName) {
        Toast({
          message: "请填写文件标题"
        });
        return;
      }
      
      // 合并原有附件ID和新上传的附件ID
      const allFileIds = [...this.existingFileIds, ...this.fileIds].filter(id => id);
      
      // 确保日期格式为 yyyy-MM-dd
      let formattedApplyTime = this.applyTime;
      if (this.applyTime) {
        if (typeof this.applyTime === 'string') {
          // 如果是字符串，检查格式
          if (!/^\d{4}-\d{2}-\d{2}$/.test(this.applyTime)) {
            // 如果不是 yyyy-MM-dd 格式，尝试解析并格式化
            const date = new Date(this.applyTime);
            if (!isNaN(date.getTime())) {
              formattedApplyTime = this.formatDate(date);
            }
          }
        } else if (this.applyTime instanceof Date) {
          formattedApplyTime = this.formatDate(this.applyTime);
        }
      }
      
      let params = {
        documentId: this.documentId,
        company: this.company,
        applyTime: formattedApplyTime,
        documentnum: this.documentnum,
        documentName: this.documentName,
        nameuser: this.nameuser,
        fileIds: allFileIds.join(',')
      };
      
      axios({
        url: process.env.VUE_APP_SSO_URL + "appUpdateProposedDocument",
        method: "POST",
        data: params
      }).then(res => {
        Toast({
          message: "修改成功",
          position: 'middle',
          iconClass: "icon icon-success"
        });
        this.goBack();
      }).catch(err => {
        Toast({
          message: (err.response && err.response.data) || "修改失败",
          position: 'middle'
        });
      });
    }
  },
};
</script>

<style lang="less">
@color: #ffffff;
@border-rd: 10px;

html {
  overflow: hidden;
  height: 100%;
  background: #f5f5f5;
}
.delete-btn {
  color: red;
  cursor: pointer;
  margin-left: 10px;
  font-size: 50px;
  font-weight: bold;
}
.mint-cell-label {
  font-size: 1.2rem !important;
  font-weight: 700;
  color: #6d9eeb !important;
  margin-left: -20px;
}
body {
  display: block;
  margin: 0rem !important;
}
.app {
  background-color: rgb(240, 240, 240, 0.75);
}

.userinfoAdd {
  margin-left: 1rem;
  height: 20rem;
  line-height: 3rem;
  .van-field__control {
    line-height: 2rem;
    font-size: 1.5rem !important;
    margin-top: 10px;
  }
  .van-field__label {
    span {
      font-size: 1.2rem !important;
      font-weight: 700;
      color: #6d9eeb;
    }
    line-height: 2rem;
    font-size: 2rem !important;
    margin-top: -20px;
  }
  .van-field__value {
    line-height: 2rem;
    font-size: 2rem !important;
    margin-top: 10px;
  }
  .van-cell {
    align-items: center;
    .van-field__label {
      width: 400px;
      font-size: 60px;
      height: 100px;
      line-height: 100px;
      color: #382c2c;
    }
  }
  .van-field__body {
    input {
      border: none !important;
      color: black;
    }
    textarea {
      padding-left: 30px;
    }
  }
  .field-vertical-wrapper {
    padding: 0;
    border-bottom: 1px solid #e0d8d8;
    .field-vertical-label {
      font-size: 1.2rem !important;
      font-weight: 700;
      color: #6d9eeb;
      margin-bottom: 0.5rem;
      margin-left: 0;
      padding: 0;
      line-height: 2rem;
      margin-top: -10px;
      span {
        font-size: 1.2rem !important;
        font-weight: 700;
        color: #6d9eeb;
      }
    }
    .field-vertical-input {
      .van-field__label {
        display: none !important;
      }
      .van-field__value {
        width: 100% !important;
      }
      .van-field__control {
        width: 100% !important;
        white-space: normal !important;
        word-wrap: break-word !important;
        word-break: break-all !important;
        overflow: visible !important;
        text-overflow: unset !important;
        font-size: 1.5rem !important;
        line-height: 2rem !important;
        min-height: 2rem !important;
      }
      input {
        width: 100% !important;
        border: none !important;
        color: black !important;
        font-size: 1.5rem !important;
        line-height: 2rem !important;
        min-height: 2rem !important;
      }
      textarea {
        width: 100% !important;
        border: none !important;
        color: black !important;
        font-size: 1.5rem !important;
        line-height: 2rem !important;
        min-height: 3rem !important;
        resize: none !important;
        padding: 0.5rem 0 !important;
      }
    }
  }
  .nameusersub {
    width: 20%;
    height: 100px;
    line-height: 100px;
    font-size: 50px;
    background: #5cb85c;
    border-radius: 50px 50px 50px 50px;
    text-align: center;
    cursor: pointer;
    color: #e5f4f9;
    margin-left: 10px;
  }
  .sub {
    width: 100%;
    height: 200px;
    line-height: 200px;
    font-size: 75px;
    background: #5f9cf5;
    border-radius: 50px 50px 50px 50px;
    text-align: center;
    cursor: pointer;
    color: #e5f4f9;
    margin-top: 100px;
  }
}
.system-pageAddD {
  width: 22rem;
  height: 100vh;
  background-color: #fff;
  font-family: "PingFangSC-Regular";
}

/** 加载中 */
.back-loading {
  width: 100%;
  height: 100%;
  background-color: white;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  text-align: center;
  line-height: 25rem;
  font-size: 1rem;
  color: grey;
}
.van-field__error-message {
  line-height: 1.3rem;
}
</style>
